import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogProps, ReservationCard, Reservation } from '@expressable/syntax-ds';
import { getReservationScheduleProps } from 'utils/date';
import { format } from 'date-fns';
import { TimeZone } from 'domains/timezone';

type Props = DialogProps & {
  onConfirm: () => void;
  appointment?: {
    timeSlot?: Date;
    therapistName?: string;
    timezone?: TimeZone;
  };
};

export const DirectSignupPreBookErrorDialog = ({ onConfirm, appointment, ...dialogProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog {...dialogProps}>
      <Dialog.Header>
        <Dialog.Title>{t(`signup.direct.steps.prebook.error.title`)}</Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>
        <div className="space-y-[30px]">
          <div>{t(`signup.direct.steps.prebook.error.description`)}</div>
          <div>
            {appointment?.timeSlot && (
              <ReservationCard title={t('signup.direct.steps.prebook.eval.reservation.confirmed')}>
                <Reservation
                  title={t('directSignup.eval.schedule.reservation.appointment')}
                  {...getReservationScheduleProps({
                    dateTime: appointment.timeSlot,
                    therapistName: appointment.therapistName,
                    pluralize: true,
                    showStarting: true,
                    formatFn: format,
                    timezone: appointment.timezone,
                  })}
                />
              </ReservationCard>
            )}
          </div>
        </div>
      </Dialog.Body>
      <Dialog.CTAs>
        <Button onClick={onConfirm}>{t(`signup.direct.steps.prebook.error.confirm`)}</Button>
      </Dialog.CTAs>
    </Dialog>
  );
};
